import Vue from "vue";
import Vuex from "vuex";

import * as actions from "./actions";
import * as mutations from "./mutations";

// import i18n from '~/i18n'
import notifications from "./modules/notifications";
import layout from "./modules/layout";
import video from "./modules/video";
// User
import contentCourses from "./modules/user/content-courses";
// dashbord
//// refactore store
import auth from "./modules/auth/";
import navbar from "./modules/navbar/";
import blog from "./modules/blog/";
import basket from "./modules/basket/";
import InstructorForm from "./modules/instructor-form/";
import courses from "./modules/courses/";
import categories from "./modules/categories/";
/// dashbord 
import dashboardAllCourses from "./modules/dashboard/all-courses/";
import Daccounting from "./modules/dashboard/accounting/";
import dashboardBlog from "./modules/dashboard/blog/";
import dashboardCategory from "./modules/dashboard/category/";
import dashboardComments from "./modules/dashboard/comments/";
import dashboardCourseForm from "./modules/dashboard/course-form/";
import dashboardDiscusses from "./modules/dashboard/discusses/";
import dashboardaFvorite from "./modules/dashboard/favorite/";
import dashboardmyCourses from "./modules/dashboard/my-courses/";
import dashboardmyTickets from "./modules/dashboard/my-tickets/";
import dashboardPassword from "./modules/dashboard/password/";
import dashboardPayment from "./modules/dashboard/payment/";
import dashboardProfile from "./modules/dashboard/profile/";
import dashboardSections from "./modules/dashboard/sections/";
import dashboardRules from "./modules/dashboard/rules/";
import dashboardSidebar from "./modules/dashboard/sidebar/";
import dashboardSubcategory from "./modules/dashboard/subcategory/";
import dashboardTag from "./modules/dashboard/tag/";
import dashboardTickets from "./modules/dashboard/tickets/";
import dashboardUsers from "./modules/dashboard/users/";
import dashboardDashboard from "./modules/dashboard/dashboard/";
import dashboardCalls from "./modules/dashboard/calls/";



import dashboardGoals from "./modules/dashboard/goals/";
import dashboardInstructors from "./modules/dashboard/instructors/";
import dashboardMessages from "./modules/dashboard/messages/";
import dashboardMonitoring from "./modules/dashboard/monitoring/";
import dashboardOfferCode from "./modules/dashboard/offer-code/";
import dashboardOffers from "./modules/dashboard/offers/";

Vue.use(Vuex);
export const store = new Vuex.Store({
  strict: false,
  modules: {
    //// refactore store
    navbar,
    blog,
    ////
    layout,
    auth,
    courses,
    categories,
    notifications,
    video,
    basket,
    contentCourses,
    dashboardSidebar,
    dashboardProfile,
    dashboardAllCourses,
    dashboardBlog,
    dashboardCategory,
    dashboardComments,
    dashboardaFvorite,
    dashboardDiscusses,
    dashboardDashboard,
    dashboardCalls,
    dashboardCourseForm,
    dashboardGoals,
    dashboardInstructors,
    dashboardMessages,
    dashboardMonitoring,
    dashboardOffers,
    dashboardOfferCode,
    dashboardmyTickets,
    dashboardmyCourses,
    dashboardPassword,
    dashboardPayment,
    dashboardRules,
    dashboardSections,
    dashboardSubcategory,
    dashboardTag,
    dashboardUsers,
    dashboardTickets,
    InstructorForm,
    Daccounting
  },
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js